/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

interface DashboardCardProps {
  readonly title: string;
  readonly subtitle: string;
  readonly action?: JSX.Element;
  readonly children: JSX.Element;
}

/** The titled white panel used by every admin-dashboard section (Figma cards). */
export function DashboardCard({
  title,
  subtitle,
  action,
  children,
}: DashboardCardProps): JSX.Element {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-900">
      <div className="mb-4 flex items-start justify-between">
        <div>
          <p className="font-semibold text-slate-800 dark:text-slate-100">{title}</p>
          <p className="text-xs text-slate-400">{subtitle}</p>
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
